import { Table, TableBody, TableCell } from '@sanlam-glacier/app-common/components';
import { TableHeader } from 'components/organisms/table';
import DocumentsRequiredRow from './DocumentsRequiredRow';
import { documentsRequestTableHeaderData } from 'modules/case-tracking/utils/documents-required/documents-required-table.function';
import { DocumentsRequired } from 'modules/case-tracking/types/documents-required/documents-required.types';

type DocumentsRequestedTableProps = {
  documents: DocumentsRequired[];
};

const DocumentsRequiredTable = ({ documents }: DocumentsRequestedTableProps) => {
  return (
    <Table>
      <TableHeader headers={documentsRequestTableHeaderData} align={TableCell.ALIGN.LEFT} />
      <TableBody>
        {documents.map((row, index) => (
          <DocumentsRequiredRow key={index} row={row} />
        ))}
      </TableBody>
    </Table>
  );
};

export default DocumentsRequiredTable;
